import React from 'react';
import T from 'Components/Helpers/translate';
import type { AgentApproval } from 'Resources/AgentApprovals';
import { asUntrustedSource, type UntrustedSource } from './types';

/** Why a turn that read outside content asks before it writes. */
const UntrustedSourceNote = ({ source }: { source: UntrustedSource }) => (
	<p className="text-body-sm text-muted-foreground">
		{T('assistant.untrustedSource.reason', { source: T(`assistant.untrustedSource.source.${source}`) })}
	</p>
);

/** The same note on an inbox approval, read from the marker stored on its payload. */
export const InboxUntrustedNote = ({ approval }: { approval: AgentApproval }) => {
	const source = asUntrustedSource(approval.actionPayload?.untrustedSource);
	return source ? <UntrustedSourceNote source={source} /> : null;
};

export default UntrustedSourceNote;
